<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  components: {
  },
  destroyed() {
//    this.$store.dispatch('master/init');
  }
}

</script>